var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 7C14.625 6.1712 14.2958 5.37634 13.7097 4.79029C13.1237 4.20424 12.3288 3.875 11.5 3.875C10.6712 3.875 9.87634 4.20424 9.29029 4.79029C8.70424 5.37634 8.375 6.1712 8.375 7C8.375 7.8288 8.70424 8.62366 9.29029 9.20971C9.87634 9.79576 10.6712 10.125 11.5 10.125C12.3288 10.125 13.1237 9.79576 13.7097 9.20971C14.2958 8.62366 14.625 7.8288 14.625 7ZM6.5 7C6.5 5.67392 7.02678 4.40215 7.96447 3.46447C8.90215 2.52678 10.1739 2 11.5 2C12.8261 2 14.0979 2.52678 15.0355 3.46447C15.9732 4.40215 16.5 5.67392 16.5 7C16.5 8.32608 15.9732 9.59785 15.0355 10.5355C14.0979 11.4732 12.8261 12 11.5 12C10.1739 12 8.90215 11.4732 7.96447 10.5355C7.02678 9.59785 6.5 8.32608 6.5 7ZM4.67578 20.125H18.3281C17.9805 17.6523 15.8555 15.75 13.2891 15.75H9.71875C7.15234 15.75 5.02734 17.6523 4.67969 20.125H4.67578ZM2.75 20.8398C2.75 16.9922 5.86719 13.875 9.71484 13.875H13.2852C17.1328 13.875 20.25 16.9922 20.25 20.8398C20.25 21.4805 19.7305 22 19.0898 22H3.91016C3.26953 22 2.75 21.4805 2.75 20.8398Z",
    fill: "#040404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/personIcon.7c774c3e6becad327d7e5997864a47bd.svg";
export { ForwardRef as ReactComponent };